const loadConfigJson = async (path: string) => {
    try {
        const response = await fetch(path);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        // console.error(error);
        return null;
    }
}

export async function updateConfig(config) {
    try {
        const configJson = await loadConfigJson('/config.json');
        const mappingJson = await loadConfigJson('/mapping.json');
        const white_label = await loadConfigJson('/white_label.json');
        config.BASE_URL = configJson?.API_BASE_ENDPOINT ?? config.BASE_URL;
        config.API_URL = configJson?.API_ENDPOINT ?? config.API_URL;
        config.PROXY_API_URL = configJson?.PROXY_API_ENDPOINT ?? config.PROXY_API_URL;
        config.rtc.host = configJson?.API_RTC_ENDPOINT ?? config.rtc.host;
        config.mappings = mappingJson ?? config.mappings;
        config.white_label = white_label ?? config.white_label;

        return config;
    } catch (error) {
        // console.error(error);
        return config;
    }
};